import React from 'react';
import styled from 'styled-components';

import { Button } from '../atom/Button';
import { Flex } from '../atom/Layout';

export const ButtonWithLogo = ({ logo, children, ...props }) => (
  <Button {...props}>
    <Flex style={{ widht: '100%' }}>
      <LogoStyle src={logo} />
      {children}
    </Flex>
  </Button>
);

const LogoStyle = styled.img`
  width: calc(2400vw / 375);
  max-width: 38px;
  margin-right: 9.6px;
`;
